import(/* webpackMode: "eager" */ "/codegiant/app/globals.css");
import(/* webpackMode: "eager" */ "/codegiant/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/codegiant/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/codegiant/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/codegiant/components/ui/tooltip.tsx")